import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'acan-date',
  templateUrl: './acan-date.component.html',
  styleUrls: ['./acan-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AcanDateComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AcanDateComponent implements ControlValueAccessor {
  @Input() placeholder = '';
  @Input() showIcon = true;
  @Input() dateFormat = 'dd/mm/yy';
  @Input() selectionMode: 'single' | 'multiple' | 'range' = 'single';
  @Input() showTime = false;

  value: Date | Date[] | null = null;
  disabled = false;

  private onChange: (value: Date | Date[] | null) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: Date | Date[] | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: Date | Date[] | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: Date | Date[] | null): void {
    this.value = value;
    this.onChange(value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
